<template>
  <v-data-table
    class="elevation-1 cursor-pointer"
    :headers="headers"
    :items="items"
    :loading="cargando"
    :items-per-page="-1"
    loading-text="Cargando tipos de lista de precio..."
    no-data-text="No se encontraron registros"
    hide-default-footer
    dense>
    <template v-slot:item="{ item, index, headers: cols }">
      <tr
        :class="{ 'primary lighten-5': itemSeleccionado && itemSeleccionado.id === item.id }"
        style="cursor: pointer"
        @click="seleccionarFila(item)">
        <td v-for="col in cols" :key="col.value">
          <template v-if="col.value === 'numero'">
            <span class="text-caption grey--text text--darken-1">{{ index + 1 }}</span>
          </template>
          <template v-else-if="col.value === 'nombre'">
            <span class="font-weight-medium">{{ item.nombre }}</span>
          </template>
          <template v-else-if="col.value === 'creadoEn'">
            <span class="text-caption">{{ formatearFecha(item.creadoEn) }}</span>
          </template>
          <template v-else-if="col.value === 'actualizadoEn'">
            <span class="text-caption">{{ formatearFecha(item.actualizadoEn) }}</span>
          </template>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ListadoTipoListaPrecio',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    itemSeleccionado: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        { text: '#', value: 'numero', sortable: false, width: '60px' },
        { text: 'Nombre', value: 'nombre', sortable: false },
        { text: 'Creado en', value: 'creadoEn', sortable: false, width: '180px' },
        { text: 'Actualizado en', value: 'actualizadoEn', sortable: false, width: '180px' },
      ],
    };
  },
  methods: {
    seleccionarFila(item) {
      this.$emit('seleccionar', item);
    },
    formatearFecha(fecha) {
      if (!fecha) return '-';

      const date = new Date(fecha);
      return date.toLocaleDateString('es-BO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>
